<template>
  <div class="lower-limb-orthosis-step-three-b">
    <v-layout
      justify-space-between
      wrap
    >
      <v-btn
        block
        @click="$emit('show-drawing')"
      >
        Dessin
      </v-btn>
      <v-flex sm6>
        <div class="content">
          <div class="img-container">
            <img src="@/assets/img/schema_omi_3b1.svg">
            <v-text-field
              v-model="form.schematic_whole_leg_c1"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) C1"
              :class="{ error: errors.has('(Schéma Jambe Entière) C1') }"
              outlined
              type="number"
              style="top: 4.4%;left: 83%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_a2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) A2"
              :class="{ error: errors.has('(Schéma Jambe Entière) A2') }"
              outlined
              type="number"
              style="top: 13%;left: 39.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_b2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) B2"
              :class="{ error: errors.has('(Schéma Jambe Entière) B2') }"
              outlined
              type="number"
              style="top: 13%;left: 58.7%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_c2"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) C2"
              :class="{ error: errors.has('(Schéma Jambe Entière) C2') }"
              outlined
              type="number"
              style="top: 13%;left: 83%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_a3"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) A3"
              :class="{ error: errors.has('(Schéma Jambe Entière) A3') }"
              outlined
              type="number"
              style="top: 48.3%;left: 39.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_b3"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) B3"
              :class="{ error: errors.has('(Schéma Jambe Entière) B3') }"
              outlined
              type="number"
              style="top: 48.3%;left: 58.7%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_a4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) A4"
              :class="{ error: errors.has('(Schéma Jambe Entière) A4') }"
              outlined
              type="number"
              style="top: 84%;left: 39.4%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_b4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) B4"
              :class="{ error: errors.has('(Schéma Jambe Entière) B4') }"
              outlined
              type="number"
              style="top: 84%;left: 58.7%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_c4"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) C4"
              :class="{ error: errors.has('(Schéma Jambe Entière) C4') }"
              outlined
              type="number"
              style="top: 84%;left: 83%;"
              height="100%"
            />
            <v-text-field
              v-model="form.schematic_whole_leg_c5"
              v-validate="'numeric|max:4'"
              data-vv-name="(Schéma Jambe Entière) C5"
              :class="{ error: errors.has('(Schéma Jambe Entière) C5') }"
              outlined
              type="number"
              style="top: 91.8%;left: 83%;"
              height="100%"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "LowerLimbOrthosisStepThreeB",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  created() {
    this.$validator = this.parentValidator;
  }
};
</script>

<style lang="scss">
.lower-limb-orthosis-step-three-b {
  .content {
    display: flex;
    // min-height: 80vh;
    max-height: 600px;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 16%;
        height: 8.2%;
        // @media (max-width: 800px) {
        //   height: 4.4%;
        // }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .canvas-container {
    width: 100%;
    height: 600px;
    max-height: 40vh;
    display: flex;
    .canvas-item {
      height: 100%;
      width: 100%;
      background-color: purple;
    }
  }
}
</style>
